<template>
  <component
    :is="titleTag"
    v-if="value.title"
    :class="[
      titleClass,
      hasBody ? 'mb-4' : '',
      titleCenter ? 'text-center' : ''
    ]"
  >
    <StyledText :em-class="emClassTitle" :value="value.title" />
  </component>

  <component
    :is="subtitleTag"
    v-if="value.subtitle"
    :class="[
      subtitleClass,
      hasBody ? 'mb-4' : '',
      titleCenter ? 'text-center' : ''
    ]"
  >
    <StyledText :value="value.subtitle" />
  </component>

  <template v-if="Array.isArray(value.paragraphs)">
    <p v-for="(p, i) in value.paragraphs" :key="i" :class="paragraphClass">
      <StyledText :em-class="emClassParagraph" :value="p" />
    </p>
  </template>

  <p v-else-if="value.paragraph" :class="paragraphClass">
    <StyledText :em-class="emClassParagraph" :value="value.paragraph" />
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { TitleParagraphBlockValue } from '#root/types/title-paragraph-block'

const props = withDefaults(
  defineProps<{
    emClassParagraph?: string
    emClassTitle?: string
    paragraphClass?: string
    subtitleClass?: string
    subtitleTag?: string
    titleCenter?: boolean
    titleClass?: string
    titleTag?: string
    value: TitleParagraphBlockValue
  }>(),
  {
    emClassParagraph: 'font-weight-medium',
    emClassTitle: 'font-weight-medium',
    paragraphClass: 'text-body-0 mb-2',
    subtitleClass: 'text-h5 font-weight-regular',
    subtitleTag: 'h4',
    titleCenter: false,
    titleClass: 'text-h5 text-sm-h4 font-weight-medium',
    titleTag: 'h2'
  }
)

const hasBody = computed(
  () => !!(props.value.paragraph || Array.isArray(props.value.paragraphs))
)
</script>
